import { Button, Grid, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import CustomToolTip from "../CustomTooltip";

const SwitchButton = ({
  selectedLogic,
  onChange,
  logicsAndLabels,
  TooltipSwitch = {},
  sx = {},
}) => {
  const colors = useColors();

  const selectedSx = {
    backgroundColor: colors.primary_8percent,
    color: colors.primary_main,
    textTransform: "none",
    width: "100%",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: colors.primary,
    },
  };
  const unselectedSx = {
    backgroundColor: "transparent",
    color: colors.text_primary,
    textTransform: "none",
    width: "100%",
    borderRadius: "8px",

    "&:hover": {
      backgroundColor: colors.grey_8percent,
    },
  };

  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        border: "1px solid " + colors.grey_8percent,
        borderRadius: "8px",
        minWidth: "250px",
        gap: "4px",
        padding: "4px",
        ...sx,
      }}
    >
      {Object.entries(logicsAndLabels).map(([logic, label], index) => (
        <Grid item xs={5.8} key={index}>
          <CustomToolTip
            placement="top"
            title={TooltipSwitch[logic] ? TooltipSwitch[logic] : ""}
          >
            <Button
              onClick={() => onChange(logic)}
              sx={
                selectedLogic === logic
                  ? { ...selectedSx }
                  : { ...unselectedSx }
              }
            >
              <Typography
                variant={selectedLogic === logic ? "overline" : "caption"}
              >
                {label}
              </Typography>
            </Button>
          </CustomToolTip>
        </Grid>
      ))}
    </Grid>
  );
};

export default SwitchButton;
